<template>
  <v-layout pl-2 pt-2 pr-2 pb-2 justify-center row>
    <v-flex xs4 lg2>
      <SimpleCard>
        <InvoicePolicyActionBox @createInvoicePolicy="createInvoicePolicy" :query="query"></InvoicePolicyActionBox>
      </SimpleCard>
    </v-flex>
    <v-flex xs8 lg10 pl-2>
      <SimpleCard>
        <v-layout row wrap align-content-center justify-center>
          <v-flex v-if="loading" xs12 pa-2 class="text-xs-center">
            <v-progress-circular :size="48" :width="5" color="primary" indeterminate></v-progress-circular>
          </v-flex>
          <InvoicePolicyList
            v-if="!loading"
            style="width: 100%;"
            :invoicePolicyList="invoicePolicies"
            :paginationProp="pagination"
            @select="editInvoicePolicy"
          ></InvoicePolicyList>
          <v-flex v-if="!loading" pt-2 xs9 class="text-xs-center pt-2">
            <v-pagination @input="changePage" v-model="pagination.page" :length="num_pages"></v-pagination>
          </v-flex>
        </v-layout>
      </SimpleCard>
    </v-flex>
    <template>
      <v-row justify="center">
        <v-dialog persistent v-model="dialog" max-width="600px">
          <v-card>
            <v-card-title>
              <span
                class="headline"
              >{{ service.id != null ? 'Edit Account Invoice Policy' : 'Create Account Invoice Policy' }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-flex xs12>
                    <v-text-field v-model="service.name" label="Service Name*" required></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field v-model="service.short_name" label="Name for Driver*" required></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-autocomplete
                      v-model="service.user"
                      :items="customerList"
                      :loading="loading"
                      :search-input.sync="search"
                      item-text="name"
                      label="Customer Search*"
                      hide-no-data
                      hide-selected
                      no-filter
                      return-object
                      @change="customerSelected"
                      required
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12>
                    <v-checkbox v-model="service.enabled" label="Enabled" required></v-checkbox>
                  </v-flex>
                </v-row>
              </v-container>
              <small>*indicates required field</small>
            </v-card-text>
            <v-card-actions>
              <v-flex grow></v-flex>
              <v-btn class="text-none light" flat text @click="dialog = false">Cancel</v-btn>
              <v-btn
                :disabled="!(service.name.length > 0 && service.short_name.length > 0 && service.user.id != undefined)"
                class="text-none light"
                color="blue lighten-1"
                text
                @click="service.id != null ? edit() : create() "
              >{{ service.id != null ? 'Edit' : 'Create'}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </v-layout>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
import InvoicePolicyList from "@/components/account_invoice_policy/InvoicePolicyList.vue";
import InvoicePolicyActionBox from "@/components/account_invoice_policy/InvoicePolicyActionBox.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "repeat_service",
  components: {
    SimpleCard,
    InvoicePolicyList,
    InvoicePolicyActionBox
  },
  data: function() {
    return {
      dialog: false,
      invoicePolicies: [],
      offset: 0,
      count: 20,
      query: {
        enabledOnly: false
      },
      loading: true,
      pagination: { page: 1 },
      num_pages: 0,
      search: null,
      customers: [],
      service: {
        name: "",
        short_name: "",
        user: {},
        enabled: true
      }
    };
  },
  computed: {
    customerList: function() {
      return this.customers;
    }
  },
  watch: {
    search(val) {
      if (val == null) return;
      if (val.length <= 1) return;

      var url = `${this.$store.state.apiUrl}/customer/search?query=${val}`;

      var searchCompleted = this.searchCompleted;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          searchCompleted(res.data);
        })
        .catch(function(err) {
          console.error(err);
          this.loading = false;
        });
    }
  },
  mounted: async function() {
    this.get();
  },
  methods: {
    create: async function() {
      this.dialog = false;

      var vm = this;

      try {
        let response = await axios.post(
          `${this.$store.state.apiUrl}/account_invoice_policy/create?name=${this.service.name}&short_name=${this.service.short_name}&user_id=${this.service.user.id}&enabled=${this.service.enabled}`,
          {},
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }
        );

        if (response.data.error == "no_error") {
          vm.get();
        } else {
          alert(response.data.error);
        }
      } catch (error) {
        console.log(error);
        alert("Unknown error");
      }
    },
    edit: async function() {
      this.dialog = false;

      var vm = this;

      try {
        let response = await axios.post(
          `${this.$store.state.apiUrl}/account_invoice_policy/update/${this.service.id}?name=${this.service.name}&short_name=${this.service.short_name}&enabled=${this.service.enabled}`,
          {},
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }
        );

        if (response.data.error == "no_error") {
          vm.get();
        } else {
          alert(response.data.error);
        }
      } catch (error) {
        console.log(error);
        alert("Unknown error");
      }
    },
    searchCompleted: function(data) {
      this.customers = data.customers;

      this.loading = false;
    },
    customerSelected: function(customer) {
      console.log("Changed " + JSON.stringify(customer));
    },
    createInvoicePolicy: function() {
      console.log("Creating invoice policy for account");

      this.service = {
        name: "",
        short_name: "",
        user: {},
        enabled: true
      };

      this.dialog = true;
    },
    editInvoicePolicy: function(invoicePolicy) {
      console.log("Editing invoice policy for account");

      this.service = invoicePolicy;

      this.dialog = true;
    },
    search: function() {
      this.pagination.page = 1;
      this.get();
    },
    clear: function() {
      this.query = {
        includeCancelled: "all"
      };
    },
    changePage: function(page) {
      this.pagination.page = page;
      console.log(page);
      this.get();
    },
    get: async function() {
      this.loading = true;

      try {
        var url = `${
          this.$store.state.apiUrl
        }/account_invoice_policy/all?offset=${this.count *
          (this.pagination.page - 1)}&count=${this.count}&enabled_only=${
          this.query.enabledOnly
        }`;

        let response = await axios.get(url, {
          params: {}
        });

        this.invoicePolicies = response.data.account_invoice_policies;
        this.num_pages = response.data.num_pages;

        console.log(response.data.num_pages);

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get account invoice policies" + error);
      }
    },
    failed: function(data) {
      alert("Request Failed with error: " + data.message);
    }
  }
};
</script>
